<template>
  <div class="form-horizontal">
    <div class="form-group">
      <label class="control-label col-sm-4">{{action}}:</label>
      <div class="col-sm-8" v-if="hasPermission && editEnabled">
        <multiselect
            @open="getOptions(action)"
            :ref="`multiselect-${resource}`"
            v-model="selection"
            :options="options"
            placeholder="Bitte wählen Sie eine Option"
            :multiple="true"
            :hideSelected="true"
            :loading="isLoading"
            track-by="id"
            label="value"
        ></multiselect>
      </div>
      <div class="col-sm-8" v-else>
        <span v-for="s in selection" class="label label-success mr-5">{{s.value}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import Api from '@/services/Api'
  export default {
    props: ['action', 'resource', 'permissions', 'hasPermission', 'editEnabled'],
    name: "EditRoleRow",
    data () {
      return {
        options: [],
        isLoading: false
      }
    },
    computed: {
      selection: {
        get: function () {
          return this.permissions
        },
        set: function (newValue) {
          this.$emit('select', {props: newValue, resource: this.resource, action: this.action} )
        }
      }
    },
    methods: {
      getOptions (action) {
        this.isLoading = true
        Api().get(`/frontend/permission/${this.resource}?action=${action}`)
          .then(response => {
            this.isLoading = false
            this.options = response.data
          })
      },
      updateProp (event) {
        this.$emit('select', {props: this.selection, resource: this.resource, action: this.action} )
      }
    }
  }
</script>

<style scoped>
</style>
